import { Injectable } from "@angular/core";
import { lastValueFrom, Observable } from "rxjs";
import { DataResult, ICRUD } from '@phx-erp/shared';
import { BaseListService } from "../../../@core/services/base-list.service";
import { SystemService } from "../../../@core/services/system.service";
import { DELETE_DISCOUNT_GROUP_PRODUCT_RELATION, GET_DISCOUNT_GROUP_PRODUCT_RELATION, GET_DISCOUNT_GROUP_PRODUCT_RELATIONS, SAVE_DISCOUNT_GROUP_PRODUCT_RELATION } from "../../../data/definitions/discount-group-product-relation.definition";
import { QueryResult } from "../../../data/query-result";
import { BaseDataService } from "../../../data/services/base-data.service";
import { DeleteDiscountGroupProductRelationMutation, DeleteDiscountGroupProductRelationMutationVariables, DeletionResponse, DiscountGroupProductRelation, DiscountGroupProductRelationInput, DiscountGroupProductRelationSearchInput, GetDiscountGroupProductRelationQuery, GetDiscountGroupProductRelationQueryVariables, GetDiscountGroupProductRelationsQuery, GetDiscountGroupProductRelationsQueryVariables, SaveDiscountGroupProductRelationMutation, SaveDiscountGroupProductRelationMutationVariables } from "../../../generated/generated-types";

@Injectable({
    providedIn: 'root'
})
export class DiscountGroupProductRelationService extends BaseListService<DiscountGroupProductRelation> implements ICRUD<DiscountGroupProductRelation> {
    constructor(
        private baseDataService: BaseDataService,
        private systemService: SystemService,
    ) {
        super();
    }

    getData(searchInput?: DiscountGroupProductRelationSearchInput/*, options?: ICRUDOptions*/): Observable<DataResult<DiscountGroupProductRelation>> {
        return super.getData(searchInput);
    }

    getItems(searchInput: DiscountGroupProductRelationSearchInput): QueryResult<GetDiscountGroupProductRelationsQuery> {
        let fragment = GET_DISCOUNT_GROUP_PRODUCT_RELATIONS;

        return this.baseDataService.query<GetDiscountGroupProductRelationsQuery, GetDiscountGroupProductRelationsQueryVariables>(
            fragment, {
            input: searchInput
        });
    }

    getItem(id: string): QueryResult<GetDiscountGroupProductRelationQuery> {
        return this.baseDataService.query<GetDiscountGroupProductRelationQuery, GetDiscountGroupProductRelationQueryVariables>(
            GET_DISCOUNT_GROUP_PRODUCT_RELATION, {
            id: id
        });
    }

    async getItemData(id: string): Promise<DiscountGroupProductRelation> {
        return (await lastValueFrom(await this.getItem(id).mapSingle(x => x.getDiscountGroupProductRelation as DiscountGroupProductRelation)));
    }

    getItemStream(id: string): Observable<DiscountGroupProductRelation> {
        return this.getItem(id).mapStream(x => x.getDiscountGroupProductRelation as DiscountGroupProductRelation);
    }

    async saveItem(item: DiscountGroupProductRelationInput): Promise<DiscountGroupProductRelation> {
        // if (!item.type)
        //     item.type = DiscountGroupType.PRODUCT;

        let validated = await this.systemService.validateObject<DiscountGroupProductRelationInput>(item, "DiscountGroupProductRelationInput");

        let saved = await lastValueFrom(await this.baseDataService.mutate<SaveDiscountGroupProductRelationMutation, SaveDiscountGroupProductRelationMutationVariables>(
            SAVE_DISCOUNT_GROUP_PRODUCT_RELATION, {
            input: validated
        }));
        return saved.saveDiscountGroupProductRelation as DiscountGroupProductRelation;
    }

    async deleteItem(id: string): Promise<DeletionResponse> {
        let res = await lastValueFrom(await this.baseDataService.mutate<DeleteDiscountGroupProductRelationMutation, DeleteDiscountGroupProductRelationMutationVariables>(
            DELETE_DISCOUNT_GROUP_PRODUCT_RELATION, {
            id: id
        }));

        return res.deleteDiscountGroupProductRelation;
    }
}